import { Button, CardFooter } from '@e2n/ui';
import { UpdateTerminKalenderDrawer } from '@/domain/termine/features/UpdateTerminkalender/Mobile';
import { KalenderDeleteDrawer } from '@/domain/termine/features/TerminKalender/Mobile/DeleteDrawer/KalenderDeleteDrawer';
import { useKalenderDeleteHandler } from '@/domain/termine/features/TerminKalender/shared/useKalenderDeleteHandler';
import { useTerminKalenderList } from '@/domain/termine/hooks/useTerminKalenderList';
import { TerminKalender } from '@/domain/termine/shared/types';
import { faEdit, faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line max-lines-per-function */
export function KalenderCardActions({
  kalender,
}: {
  kalender: TerminKalender;
}) {
  const [editDrawerOpen, setEditDrawerOpen] = useState(false);
  const [deleteDrawerOpen, setDeleteDrawerOpen] = useState(false);
  const { t } = useTranslation();
  const editLabel = t('domain.termine.edit');
  const deleteLabel = t('domain.termine.delete');

  const { kalender: allKalender } = useTerminKalenderList();
  const { handleDelete, loading } = useKalenderDeleteHandler(allKalender);

  const handleDeleteClick = () => {
    if ((kalender.termineCount ?? 0) === 0) {
      handleDelete(kalender);
    } else {
      setDeleteDrawerOpen(true);
    }
  };

  return (
    <CardFooter className="px-4 pb-4 pt-0 justify-start gap-2">
      <Button
        aria-label={editLabel}
        title={editLabel}
        variant="ghost"
        size="icon"
        onClick={() => setEditDrawerOpen(true)}>
        <FontAwesomeIcon
          icon={faEdit}
          className="text-primary-blue-600 w-4 h-4"
        />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className="hover:bg-transparent"
        aria-label={deleteLabel}
        title={deleteLabel}
        onClick={handleDeleteClick}>
        <FontAwesomeIcon
          icon={faTrashCan}
          className="text-primary-red-400 w-4 h-4"
        />
      </Button>
      {editDrawerOpen && (
        <UpdateTerminKalenderDrawer
          onOpenChange={setEditDrawerOpen}
          selectedId={kalender.id}
          open={editDrawerOpen}
        />
      )}
      <KalenderDeleteDrawer
        open={deleteDrawerOpen}
        onOpenChange={(open) => setDeleteDrawerOpen(open)}
        kalender={kalender}
        otherKalender={allKalender.filter((k) => k.id !== kalender.id)}
        onConfirm={async (idTargetTerminkalender) => {
          await handleDelete(kalender, idTargetTerminkalender);
          setDeleteDrawerOpen(false);
        }}
        loading={loading}
      />
    </CardFooter>
  );
}
